"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_library_1 = require("@kaizen/component-library");
var draft_avatar_1 = require("@kaizen/draft-avatar");
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var clear_white_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/clear-white.icon.svg"));
var exclamation_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/exclamation.icon.svg"));
var information_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/information.icon.svg"));
var success_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/success.icon.svg"));
var Tag_scss_1 = __importDefault(require("./Tag.scss"));
var isJSXElement = function (imageElementOrAvatarProps) {
    return "props" in imageElementOrAvatarProps;
};
var renderAvatar = function (imageElementOrAvatarProps) {
    return isJSXElement(imageElementOrAvatarProps) ? (React.createElement(React.Fragment, null, imageElementOrAvatarProps)) : (React.createElement(draft_avatar_1.Avatar, __assign({}, imageElementOrAvatarProps, { size: "small" })));
};
var Tag = function (props) {
    var _a, _b;
    var children = props.children, _c = props.variant, variant = _c === void 0 ? "default" : _c, _d = props.size, size = _d === void 0 ? "medium" : _d, _e = props.inline, inline = _e === void 0 ? false : _e, _f = props.dismissible, dismissible = _f === void 0 ? false : _f, onDismiss = props.onDismiss, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, truncateWidth = props.truncateWidth;
    var isTruncated = truncateWidth && truncateWidth > 0;
    var canShowIcon = size === "medium";
    return (React.createElement("div", { className: (0, classnames_1["default"])(Tag_scss_1["default"].root, (_a = {},
            _a[Tag_scss_1["default"]["default"]] = variant === "default" || variant === "profile",
            _a[Tag_scss_1["default"].profile] = variant === "profile",
            _a[Tag_scss_1["default"].sentimentPositive] = variant === "sentimentPositive",
            _a[Tag_scss_1["default"].sentimentNeutral] = variant === "sentimentNeutral",
            _a[Tag_scss_1["default"].sentimentNegative] = variant === "sentimentNegative",
            _a[Tag_scss_1["default"].sentimentNone] = variant === "sentimentNone",
            _a[Tag_scss_1["default"].validationPositive] = variant === "validationPositive",
            _a[Tag_scss_1["default"].validationInformative] = variant === "validationInformative",
            _a[Tag_scss_1["default"].validationNegative] = variant === "validationNegative",
            _a[Tag_scss_1["default"].validationCautionary] = variant === "validationCautionary",
            _a[Tag_scss_1["default"].statusLive] = variant === "statusLive",
            _a[Tag_scss_1["default"].statusDraft] = variant === "statusDraft",
            _a[Tag_scss_1["default"].statusClosed] = variant === "statusClosed",
            _a[Tag_scss_1["default"].statusAction] = variant === "statusAction",
            _a[Tag_scss_1["default"].medium] = size === "medium",
            _a[Tag_scss_1["default"].small] = size === "small",
            _a[Tag_scss_1["default"].inline] = inline,
            _a[Tag_scss_1["default"].dismissible] = dismissible,
            _a)) },
        React.createElement("div", { className: Tag_scss_1["default"].layoutContainer },
            canShowIcon &&
                (function () {
                    switch (props.variant) {
                        case "validationPositive":
                            return (React.createElement("span", { className: Tag_scss_1["default"].validationIcon },
                                React.createElement(component_library_1.Icon, { icon: success_icon_svg_1["default"], role: "presentation" })));
                        case "validationNegative":
                            return (React.createElement("span", { className: Tag_scss_1["default"].validationIcon },
                                React.createElement(component_library_1.Icon, { icon: exclamation_icon_svg_1["default"], role: "presentation" })));
                        case "validationCautionary":
                            return (React.createElement("span", { className: Tag_scss_1["default"].validationIcon },
                                React.createElement(component_library_1.Icon, { icon: exclamation_icon_svg_1["default"], role: "presentation" })));
                        case "validationInformative":
                            return (React.createElement("span", { className: Tag_scss_1["default"].validationIcon },
                                React.createElement(component_library_1.Icon, { icon: information_icon_svg_1["default"], role: "presentation" })));
                        case "profile":
                            return (React.createElement("span", { className: Tag_scss_1["default"].profile }, props.avatar && renderAvatar(props.avatar)));
                        default:
                            return;
                    }
                })(),
            React.createElement("span", { className: (0, classnames_1["default"])(Tag_scss_1["default"].textContent, (_b = {},
                    _b[Tag_scss_1["default"].truncate] = isTruncated,
                    _b)), style: {
                    maxWidth: isTruncated ? truncateWidth : undefined
                } }, children),
            dismissible && (React.createElement(React.Fragment, null,
                React.createElement("button", { className: Tag_scss_1["default"].dismissButton, onClick: onDismiss, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave },
                    React.createElement("div", { className: Tag_scss_1["default"].iconWrapper },
                        React.createElement(component_library_1.Icon, { icon: clear_white_icon_svg_1["default"], inheritSize: true, role: "img", title: "Dismiss" }))))),
            variant === "statusLive" && (React.createElement("span", { className: Tag_scss_1["default"].pulse },
                React.createElement("span", { className: Tag_scss_1["default"].pulseRing }))))));
};
exports["default"] = Tag;
//# sourceMappingURL=Tag.js.map